module.exports = __webpack_public_path__ + "static/media/square_checkmark_two.f9f2e8a5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/square_checkmark_two.svg
// module id = 34
// module chunks = 0